/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Jump_Bullet_1Inputs */

const en_features_jump_bullet_1 = /** @type {(inputs: Features_Jump_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening allows you to select which sections of a paper to listen to`)
};

const es_features_jump_bullet_1 = /** @type {(inputs: Features_Jump_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening te permite seleccionar qué secciones de un artículo escuchar`)
};

/**
* | output |
* | --- |
* | "Listening allows you to select which sections of a paper to listen to" |
*
* @param {Features_Jump_Bullet_1Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_jump_bullet_1 = /** @type {((inputs?: Features_Jump_Bullet_1Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Jump_Bullet_1Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_jump_bullet_1(inputs)
	return en_features_jump_bullet_1(inputs)
});